export default __webpack_public_path__ + "static/media/spotlight-modal-img.a42288c7.png";